// Ví tiền tệ. Cộng CHỈ qua grantReward (src/state/rewards.ts); trừ qua action có giá (spend).
// Topbar chỉ hiện 2 loại; ví giữ thêm Bụi, Luyện Khí Thạch, Toái Linh (GLOSSARY §6).
import { signal, computed } from '@preact/signals';
import { registerSlice } from '../registry';
import { isPlainObject } from '@save/types';
import { WALLET_CURRENCIES, isWalletCurrency, type WalletCurrency } from '@data/currencies';

export type Wallet = Record<WalletCurrency, number>;

function emptyWallet(): Wallet {
  return Object.fromEntries(WALLET_CURRENCIES.map((c) => [c, 0])) as Wallet;
}

const _wallet = signal<Wallet>(emptyWallet());
export const wallet = computed(() => _wallet.value);

registerSlice<Wallet>({
  key: 'wallet',
  scope: 'core',
  serialize: () => _wallet.value,
  hydrate: (d) => {
    const w = emptyWallet();
    if (isPlainObject(d)) {
      for (const c of WALLET_CURRENCIES) {
        const v = d[c];
        if (typeof v === 'number' && Number.isFinite(v) && v >= 0) w[c] = v;
      }
    }
    _wallet.value = w;
  },
});

/** Chỉ src/state/rewards.ts gọi (TECH_BASELINE §6.3). */
export function creditWallet(delta: Readonly<Record<string, number>>): void {
  const w = { ..._wallet.value };
  for (const [id, n] of Object.entries(delta)) if (isWalletCurrency(id) && n > 0) w[id] += n;
  _wallet.value = w;
}

/** Trừ tiền của một hành động có giá; thiếu thì không trừ gì và trả false. */
export function spend(cost: Partial<Wallet>): boolean {
  const w = { ..._wallet.value };
  for (const [id, n] of Object.entries(cost) as [WalletCurrency, number][]) {
    if (!isWalletCurrency(id) || !(n >= 0) || w[id] < n) return false;
    w[id] -= n;
  }
  _wallet.value = w;
  return true;
}

export function canAfford(cost: Partial<Wallet>): boolean {
  const w = _wallet.value;
  return (Object.entries(cost) as [WalletCurrency, number][]).every(([id, n]) => (w[id] ?? 0) >= n);
}
